import React, { useEffect, useState } from "react";
import { PlayCircleFilled } from "@ant-design/icons";
import styles from "./ThumbnailGrid.module.css";

// Renders a grid of thumbnails, given a user.
// If the user does not have thumbnails, or any of the thumbnails error,
// we'll refresh them on the backend.
const ROW_LENGTH = 6;
function ThumbnailGrid({ userId, batchId, shortcodes, thumbnails, videos }) {
  const rows =
    thumbnails && thumbnails.length
      ? [
          thumbnails.slice(0, ROW_LENGTH),
          thumbnails.slice(ROW_LENGTH, 2 * ROW_LENGTH),
        ]
      : [];

  // https://css-tricks.com/adaptive-photo-layout-with-flexbox/#all-hail-flexbox
  return rows.map((rowItems, i) => (
    <ul className={styles.wrapper} key={i}>
      {rowItems.map((thumb, index) => {
        const idx = index + i * ROW_LENGTH;
        const shortcode = shortcodes[idx];
        const video = videos[idx];
        return (
          <li key={shortcode} className={styles.item}>
            <a
              href={`https://instagram.com/p/${shortcode}`}
              target="_blank"
              rel="noreferrer"
            >
              <img src={thumb} alt="" className={styles.image} />
              {video && <PlayCircleFilled className={styles.videoIcon} />}
            </a>
          </li>
        );
      })}
    </ul>
  ));
}

export default ThumbnailGrid;
